import React, { useState } from 'react';
import { useUser, UserData } from '../../contexts/UserContext';
import { SearchIcon, UserIcon, LogInIcon, ShieldIcon, BuildingIcon, MailIcon, MapPinIcon } from 'lucide-react';
// Mock users for the admin panel
const MOCK_USERS: UserData[] = [{
  name: 'Alice Smith',
  email: 'alice@dealer.com',
  role: 'dealer',
  companyName: 'AgriTech',
  companyLogo: null,
  officialCountry: 'USA'
}, {
  name: 'Bob Jones',
  email: 'bob@customer.com',
  role: 'customer',
  companyName: 'FarmCorp',
  companyLogo: null,
  officialCountry: 'Canada'
}, {
  name: 'Carlos Ruiz',
  email: 'carlos@aisco.com',
  role: 'sales-manager',
  companyName: 'Aisco',
  companyLogo: null,
  officialCountry: 'Spain'
}, {
  name: 'Diana Prince',
  email: 'diana@aisco.com',
  role: 'region-admin',
  companyName: 'Aisco',
  companyLogo: null,
  officialCountry: 'UK'
}, {
  name: 'Elena Gomez',
  email: 'elena@dealer.com',
  role: 'dealer',
  companyName: 'Irrigo',
  companyLogo: null,
  officialCountry: 'Mexico'
}, {
  name: 'Frank Castle',
  email: 'frank@customer.com',
  role: 'customer',
  companyName: 'Punisher Farms',
  companyLogo: null,
  officialCountry: 'USA'
}, {
  name: 'George King',
  email: 'george@aisco.com',
  role: 'system-admin',
  companyName: 'Aisco',
  companyLogo: null,
  officialCountry: 'USA'
}];
export function UsersManagement() {
  const {
    role: currentRole,
    impersonateUser
  } = useUser();
  const [searchQuery, setSearchQuery] = useState('');
  // Only system-admin and region-admin can use this feature
  const canImpersonate = currentRole === 'system-admin' || currentRole === 'region-admin';
  const filteredUsers = MOCK_USERS.filter(u => u.name.toLowerCase().includes(searchQuery.toLowerCase()) || u.email.toLowerCase().includes(searchQuery.toLowerCase()) || u.companyName.toLowerCase().includes(searchQuery.toLowerCase()) || u.role.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="space-y-6" data-id="element-556">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-557">
        <div data-id="element-558">
          <h2 className="text-2xl font-bold text-white flex items-center gap-2" data-id="element-559">
            <UserIcon className="text-blue-400" data-id="element-560" />
            Users Management
          </h2>
          <p className="text-blue-300 mt-1" data-id="element-561">
            Manage users, roles, and impersonate accounts for support.
          </p>
        </div>

        <div className="relative w-full sm:w-72" data-id="element-562">
          <SearchIcon size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-blue-300/50" data-id="element-563" />
          <input type="text" placeholder="Search users..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-lg pl-10 pr-4 py-2 text-sm text-white placeholder-blue-300/50 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-564" />
        </div>
      </div>

      <div className="bg-white/5 border border-white/10 rounded-xl overflow-hidden" data-id="element-565">
        <div className="overflow-x-auto" data-id="element-566">
          <table className="w-full text-sm text-left" data-id="element-567">
            <thead className="text-xs text-blue-300 uppercase bg-white/5 border-b border-white/10" data-id="element-568">
              <tr data-id="element-569">
                <th className="px-6 py-4 font-medium" data-id="element-570">User</th>
                <th className="px-6 py-4 font-medium" data-id="element-571">Role</th>
                <th className="px-6 py-4 font-medium" data-id="element-572">Company</th>
                <th className="px-6 py-4 font-medium" data-id="element-573">Country</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-574">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5" data-id="element-575">
              {filteredUsers.map((user, idx) => <tr key={idx} className="hover:bg-white/5 transition-colors" data-id="element-576">
                  <td className="px-6 py-4" data-id="element-577">
                    <div className="flex items-center gap-3" data-id="element-578">
                      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center flex-shrink-0" data-id="element-579">
                        <span className="text-sm font-bold text-white" data-id="element-580">
                          {user.name.split(' ').map(n => n[0]).join('').substring(0, 2)}
                        </span>
                      </div>
                      <div data-id="element-581">
                        <p className="text-white font-medium" data-id="element-582">{user.name}</p>
                        <p className="text-blue-300/70 text-xs flex items-center gap-1 mt-0.5" data-id="element-583">
                          <MailIcon size={10} data-id="element-584" />
                          {user.email}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-585">
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-semibold uppercase tracking-wider bg-blue-500/20 text-blue-300 border border-blue-500/30" data-id="element-586">
                      <ShieldIcon size={10} data-id="element-587" />
                      {user.role.replace('-', ' ')}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-588">
                    <div className="flex items-center gap-2 text-blue-200" data-id="element-589">
                      <BuildingIcon size={14} className="text-blue-400/70" data-id="element-590" />
                      {user.companyName}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-591">
                    <div className="flex items-center gap-2 text-blue-200" data-id="element-592">
                      <MapPinIcon size={14} className="text-blue-400/70" data-id="element-593" />
                      {user.officialCountry}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-594">
                    {canImpersonate && <button onClick={() => impersonateUser(user)} className="inline-flex items-center gap-2 px-3 py-1.5 bg-amber-500/10 hover:bg-amber-500/20 text-amber-400 border border-amber-500/20 rounded-lg transition-colors text-xs font-medium" title={`Login as ${user.name}`} data-id="element-595">
                        <LogInIcon size={14} data-id="element-596" />
                        Login as
                      </button>}
                  </td>
                </tr>)}
              {filteredUsers.length === 0 && <tr data-id="element-597">
                  <td colSpan={5} className="px-6 py-8 text-center text-blue-300/70" data-id="element-598">
                    No users found matching your search.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}